import { render, staticRenderFns } from "./FSUserDetail.vue?vue&type=template&id=e93fafd0&scoped=true&"
import script from "./FSUserDetail.vue?vue&type=script&lang=js&"
export * from "./FSUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./FSUserDetail.vue?vue&type=style&index=0&id=e93fafd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93fafd0",
  null
  
)

export default component.exports